<template>
  <div class="row">
    <div class="col">
      <div class="titre">Consultation d'une narration</div>
    </div>
  </div>
  <div v-if="isDataLoading == true" class="row">
    <div class="col">
      <vue-loaders name="ball-beat"></vue-loaders>
    </div>
  </div>
  <div v-else class="row pb-5 accordion-element">
    <div class="col">
      <Accordion>
        <AccordionTab header="Narrations">
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col-7 lbl"><label>Numéro Cardex :</label></div>
                <div class="col-5 txt">
                  <p v-if="!numeroCardex"> ... </p>
                  <p v-else> {{numeroCardex}} </p>
                </div>
              </div>
              <div class="row">
                <div class="col-7 lbl"><label>Confidentialité :</label></div>
                <div class="col-5 txt">
                  <p v-if="!narrationLocal.confidentialiteAfficher"> ... </p>
                  <p v-else> {{ narrationLocal.confidentialiteAfficher }} </p>
                </div>
              </div>
              <div class="row"></div>
              <div class="row"  v-if="this.narrationLocal.genreReference !== 'VE '">
                <div class="col-7 lbl"><label>Numéro séquentiel :</label></div>
                <div class="col-5 txt">
                  <p v-if="!narrationLocal.numeroSequence"> ... </p>
                  <p v-else> {{ narrationLocal.numeroSequence }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col-7 lbl"><label>Montant :</label></div>
                <div class="col-5 txt">
                  <p v-if="!narrationLocal.montant"> ... </p>
                  <p v-else> {{ narrationLocal.montant }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col-7 lbl"><label>Temps consacré :</label></div>
                <div class="col-5 txt">
                  <p v-if="!narrationLocal.temps"> ... </p>
                  <p v-else> {{ narrationLocal.temps }} </p>
                </div>
              </div>

              <div class="row">
                <div class="col-7 lbl"><label>Date de approbation :</label></div>
                <div class="col-5 txt">
                  <p v-if="!approuveLe"> ... </p>
                  <p v-else> {{approuveLe}} </p>
                </div>
              </div>
              <div class="row">
                <div class="col-7 lbl"><label>Date de création :</label></div>
                <div class="col-5 txt">
                  <p v-if="!creerLe"> ... </p>
                  <p v-else> {{creerLe}} </p>
                </div>
              </div>
              <div class="row">
                <div class="col-7 lbl"><label>Date de modification :</label></div>
                <div class="col-5 txt">
                  <p v-if="!modifieLe"> ... </p>
                  <p v-else> {{modifieLe}} </p>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-7 lbl"><label>Rapporté par :</label></div>
                <div class="col-5 txt">
                  <p v-if="!narrationLocal.rapporteParDescription"> ... </p>
                  <p v-else> {{ narrationLocal.rapporteParDescription }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col-7 lbl"><label>Approuvé par :</label></div>
                <div class="col-5 txt">
                  <p v-if="!narrationLocal.approuveParDescription"> ... </p>
                  <p v-else> {{ narrationLocal.approuveParDescription }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col-7 lbl"><label>Créé par :</label></div>
                <div class="col-5 txt">
                  <p v-if="!narrationLocal.creerParDescription"> ... </p>
                  <p v-else> {{ narrationLocal.creerParDescription }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col-7 lbl"><label>Modifié par :</label></div>
                <div class="col-5 txt">
                  <p v-if="!narrationLocal.modifieParDescription"> ... </p>
                  <p v-else> {{ narrationLocal.modifieParDescription }} </p>
                </div>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConsulterChamp",
  props: ['narrationLocal', 'isDataLoading', 'numeroCardex', 'approuveLe', 'creerLe', 'modifieLe', ],
}
</script>